// Copyright (c) 2019 Deere & Company

import * as fetchService from '../../shared/services/fetch';
import { getBasePath } from '../../shared/services/get-base-path';
import { handleError } from '../../shared/services/error-handlers';
// import { getUserIdFromSessionStorage } from '../../shared/services/user-service';

const basePath = getBasePath();
// let loggedInUserId = getUserIdFromSessionStorage();

export async function getBaseCodeData ( factoryCode ) {

    const endPoint = `${basePath}/base-codes?factoryCode=${factoryCode}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getProductSubSeries ( factoryCode, seriesId ) {

    const endPoint = `${basePath}/product-subseries?factoryCode=${factoryCode}&productSeriesId=${seriesId}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function addProductSeries ( factoryCode, productName ) {

    const endPoint = `${basePath}/product-series`;

    const newProductSeries = {
        factoryCode,
        productSeriesName: productName,
        productSeriesId: 0,
    };

    const options = {
        method: 'POST',
        body: JSON.stringify( newProductSeries ),
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function editProductSeries ( factoryCode, id, productName ) {

    const endPoint = `${basePath}/product-series/`;

    const payLoad = {
        factoryCode,
        productSeriesName: productName,
        productSeriesId: id,
    };

    const options = {
        body: JSON.stringify( payLoad ),
        method: 'PUT',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function deleteProductSeries ( factoryCode, productSeriesId ) {

    const endPoint = `${basePath}/product-series/${productSeriesId}`;

    const options = {
        method: 'DELETE',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function deleteProductSubSeries ( factoryCode, id ) {

    const endPoint = `${basePath}/product-subseries/${id}`;

    const options = {
        method: 'DELETE',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getBaseCodeSearchResult ( factoryCode, text ) {

    const endPoint = `${basePath}/base-codes?factoryCode=${factoryCode}&baseCode=${text}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getBaseCodes ( factoryCode, subSeriesId ) {

    const endPoint = `${basePath}/base-codes?factoryCode=${factoryCode}&productSubSeriesId=${subSeriesId}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function editProductSubSeries ( factoryCode, productSeries, id, productName ) {

    const endPoint = `${basePath}/product-subseries/${id}`;

    const payLoad = {
        factoryCode,
        productSeriesId: productSeries.productSeriesId,
        productSeriesName: productSeries.productSeriesName,
        productSubSeriesName: productName,
        productSubSeriesId: id,
    };

    const options = {
        body: JSON.stringify( payLoad ),
        method: 'PUT',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function addProductSubSeries ( factoryCode, productSeries, productSubSeriesName ) {

    const endPoint = `${basePath}/product-subseries`;

    const payload = {
        factoryCode,
        productSeriesId: productSeries.productSeriesId,
        productSeriesName: productSeries.productSeriesName,
        productSubSeriesName,
        productSubSeriesId: 0,
    };

    const options = {
        method: 'POST',
        body: JSON.stringify( payload ),
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getFunctionCode ( factoryCode, searchParams ) {

    let searchkey = '';
    if ( searchParams.productSeries !== undefined ) {

        searchkey = `${searchkey}&productSeriesId=${searchParams.productSeries}`;

    }
    if ( searchParams.functionCode ) {

        searchkey = `${searchkey}&functionCodeName=${searchParams.functionCode}`;

    }
    const endPoint = `${basePath}/function-codes?factoryCode=${factoryCode}${searchkey}`;

    const options = {
        method: 'GET',
    };
    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getFunctionCodeList ( factoryCode, searchParams ) {

    const endPoint = `${basePath}/function-code-list?factoryCode=${factoryCode}&productSeriesList=${searchParams}`;

    const options = {
        method: 'GET',
    };
    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getPartNumber ( factoryCode, functionCode ) {

    let searchkey = '';
    if ( functionCode.productSeries !== -1 ) {

        searchkey = `${searchkey}&productSeriesId=${functionCode.productSeries}`;

    }
    if ( functionCode.functionCode ) {

        searchkey = `${searchkey}&functionCodeName=${functionCode.functionCode}`;

    }
    if ( functionCode.partNumber ) {

        searchkey = `${searchkey}&partNumber=${functionCode.partNumber}`;

    }
    if ( functionCode.manufacturingModule ) {

        searchkey = `${searchkey}&manufacturingModule=${functionCode.manufacturingModule}`;

    }
    if ( functionCode.designTeamCode ) {

        searchkey = `${searchkey}&designTeamCode=${functionCode.designTeamCode}`;

    }

    const endPoint = `${basePath}/parts?factoryCode=${factoryCode}${searchkey}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function deleteBaseCode ( factoryCode, id ) {

    const endPoint = `${basePath}/base-codes/${id}`;
    const options = {
        method: 'DELETE',
    };
    try {

        const response = await fetchService.fetch( endPoint, options );
        return response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function editBaseCode ( basecode ) {

    const endPoint = `${basePath}/base-codes/${basecode.baseCodeId}`;

    const payLoad = {
        baseCodeId: basecode.baseCodeId,
        baseCodeName: basecode.baseCodeName,
        factoryCode: basecode.factoryCode,
        productSeriesId: basecode.productSeriesId,
        productSeriesName: basecode.productSeriesName,
        productSubSeriesName: basecode.productSubSeriesName,
        productSubSeriesId: basecode.productSubSeriesId,
    };

    const options = {
        body: JSON.stringify( payLoad ),
        method: 'PUT',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getProductSubSeriesById ( subseriesId ) {

    const endPoint = `${basePath}/product-subseries/${subseriesId}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function addBaseCode ( factoryCode, basecode ) {

    const endPoint = `${basePath}/base-codes`;

    const payLoad = {
        baseCodeName: basecode.baseCodeName,
        factoryCode,
        productSeriesId: basecode.productSeriesId,
        productSeriesName: basecode.productSeriesName,
        productSubSeriesName: basecode.productSubSeriesName,
        productSubSeriesId: basecode.productSubSeriesId,
    };

    const options = {
        body: JSON.stringify( payLoad ),
        method: 'POST',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}
export async function editPartNumber ( partNumber ) {

    const endPoint = `${basePath}/function-codes/${partNumber.functionCodeId}/parts/${partNumber.partNumber}`;

    const payLoad = {
        partNumber: partNumber.partNumber,
        designTeamCode: partNumber.designTeamCode,
        manufacturingModule: partNumber.manufacturingModule,
        functionCodeId: partNumber.functionCodeId,
        functionCodeName: partNumber.functionCodeName,
        factoryCode: partNumber.factoryCode,
        productSeriesId: partNumber.productSeriesId,
        productSeriesName: partNumber.productSeriesName,
    };

    const options = {
        body: JSON.stringify( payLoad ),
        method: 'PUT',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function editComponentPartNumber ( selectedComponentFunctionCode ) {

    const componentPartId = selectedComponentFunctionCode.selObj;
    const endPoint = `${basePath}/component-parts/${componentPartId}`;

    const payLoad = {
        componentFactoryCode: selectedComponentFunctionCode.componentFactoryCode,
        componentFunctionCodeId: selectedComponentFunctionCode.componentFunctionCodeId,
        componentFunctionCodeName: selectedComponentFunctionCode.componentFunctionCodeName,
        componentGroupCode: selectedComponentFunctionCode.componentGroupCode,
        componentPartNumber: selectedComponentFunctionCode.componentPartNumber,
        manufacturingFactoryCode: selectedComponentFunctionCode.manufacturingFactoryCode,
        model: selectedComponentFunctionCode.model,
    };

    const options = {
        body: JSON.stringify( payLoad ),
        method: 'PUT',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getComponentSearchCode ( componentFunctionCodeSearch ) {

    let searchkey = '';
    if ( componentFunctionCodeSearch.componentfactoryText !== -1 ) {

        searchkey = `${searchkey}&componentFactoryCode=${componentFunctionCodeSearch.componentfactoryText}`;

    }
    if ( componentFunctionCodeSearch.componentPartNoText ) {

        searchkey = `${searchkey}&componentPartNumber=${componentFunctionCodeSearch.componentPartNoText}`;

    }
    if ( componentFunctionCodeSearch.manufacturingFactText ) {

        searchkey = `${searchkey}&manufacturingFactoryCode=${componentFunctionCodeSearch.manufacturingFactText}`;

    }
    if ( componentFunctionCodeSearch.modalCodeText ) {

        searchkey = `${searchkey}&model=${componentFunctionCodeSearch.modalCodeText}`;

    }
    if ( componentFunctionCodeSearch.componentFuncCodeText ) {

        searchkey = `${searchkey}&componentFunctionCodeName=${componentFunctionCodeSearch.componentFuncCodeText}`;

    }

    const endPoint = `${basePath}/component-parts?${searchkey}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getComponentFactoryCode () {

    const endPoint = `${basePath}/component-factory-codes`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function addPartToFunctionCode ( partNumber ) {

    const endPoint = `${basePath}/create-parts`;

    const payLoad = {
        partNumber: partNumber.partNumber,
        designTeamCode: partNumber.designTeamCode,
        manufacturingModule: partNumber.manufacturingModule,
        functionCodeId: partNumber.functionCodeId,
        functionCodeName: partNumber.functionCodeName,
        factoryCode: partNumber.factoryCode,
        productSeriesIdList: partNumber.productSeriesId,
    };

    const options = {
        body: JSON.stringify( payLoad ),
        method: 'POST',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function addPartToComponentFunctionCode ( selectedComponentFunctionCode ) {

    const endPoint = `${basePath}/component-parts`;

    const payLoad = {
        componentFactoryCode: selectedComponentFunctionCode.factoryCode,
        componentFunctionCodeId: selectedComponentFunctionCode.componentFunctionCodeId,
        componentFunctionCodeName: selectedComponentFunctionCode.componentFunctionCodeName,
        componentGroupCode: selectedComponentFunctionCode.componentGroupCode,
        componentPartNumber: selectedComponentFunctionCode.componentPartNumber,
        manufacturingFactoryCode: selectedComponentFunctionCode.manufacturingFactoryCode,
        model: selectedComponentFunctionCode.model,
    };

    const options = {
        body: JSON.stringify( payLoad ),
        method: 'POST',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function deletePartNumber ( partNumber ) {

    const endPoint = `${basePath}/function-codes/${partNumber.functionCodeId}/parts/${partNumber.partNumber}`;
    const options = {
        method: 'DELETE',
    };
    try {

        const response = await fetchService.fetch( endPoint, options );
        return response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}
export async function deleteComponentPartNumber ( selectedComponentFunctionCode ) {

    const componentPartId = `${selectedComponentFunctionCode.componentPartNumber}_${selectedComponentFunctionCode.manufacturingFactoryCode}_${selectedComponentFunctionCode.model}_${selectedComponentFunctionCode.componentFunctionCodeName}`;
    const endPoint = `${basePath}/component-parts/${componentPartId}`;
    const options = {
        method: 'DELETE',
    };
    try {

        const response = await fetchService.fetch( endPoint, options );
        return response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getPartGroups ( factoryCode, key ) {

    let searchkey = '';
    if ( key.productSeriesId ) {

        searchkey = `&productSeriesId=${key.productSeriesId}`;

    }

    const endPoint = `${basePath}/part-groups?factoryCode=${factoryCode}${searchkey}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getPartGroupsSearchResults ( factoryCode, key ) {

    const endPoint = `${basePath}/part-groups?factoryCode=${factoryCode}&partGroupName=${key}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function deletePartGroup ( partGroup ) {

    const endPoint = `${basePath}/part-groups/${partGroup.partGroupId}`;
    const options = {
        method: 'DELETE',
    };
    try {

        const response = await fetchService.fetch( endPoint, options );
        return response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}
export async function editPartGroup ( partGroup ) {

    const endPoint = `${basePath}/part-groups/${partGroup.partGroupId}`;

    const payLoad = {
        factoryCode: partGroup.factoryCode,
        partGroupDescription: partGroup.partGroupDescription,
        partGroupId: partGroup.partGroupId,
        partGroupName: partGroup.partGroupName,
        partNumber: partGroup.partNumber,
        partNumberDescription: partGroup.partNumberDescription,
        productSeriesId: partGroup.productSeriesId,
        productSeriesName: partGroup.productSeriesName,
    };

    const options = {
        body: JSON.stringify( payLoad ),
        method: 'PUT',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}
export async function addPartGroup ( factoryCode, partgroups ) {
    const endPoint = `${basePath}/part-groups`;

    const payload = {
        factoryCode,
        partGroupDescription: partgroups.partGroupDescription,
        partGroupId: partgroups.partGroupId,
        partGroupName: partgroups.partGroupName,
        partNumber: partgroups.partNumber,
        partNumberDescription: partgroups.partNumberDescription,
        productSeriesId: partgroups.productSeriesId,
        productSeriesName: partgroups.productSeriesName,
    };

    const options = {
        method: 'POST',
        body: JSON.stringify( payload ),
    };

    try {

        const response = await fetchService.fetch( endPoint, options );
        return  response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getAdminReport ( adminpage, factoryCode, productSeriesId ) {

    let url;

    switch ( adminpage ) {

    case 'warranty': url = `product-structure-report?factoryCode=${factoryCode}`; break;
    case 'functionCode': url = `function-code-report?factoryCode=${factoryCode}`; break;
    case 'componentFunctionCode': url = `component-function-code-report?componentFactoryCode=${factoryCode}`; break;
    case 'partGrp': url = `part-group-report?factoryCode=${factoryCode}`; break;
    default: url = '';

    }

    let endPoint = `${basePath}/${url}`;
    endPoint = productSeriesId !== '' ? `${endPoint}&productSeriesId=${productSeriesId}` : endPoint;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getAdminReportDownload ( response, fileName ) {

    response.blob().then( blob => {

        const url = window.URL.createObjectURL( blob );
        const a = document.createElement( 'a' );
        a.href = url;
        a.download = fileName;
        a.click();

    } );

}

export async function uploadFunctionCodeMaintenance ( file ) {

    const endPoint = `${basePath}/function-code-upload`;
    const formData = new FormData();
    formData.append( 'file', file );

    const options = {
        body: formData,
        method: 'POST',
    };

    try {

        const response = await fetchService.fetchforFileUpload( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}

export async function uploadComponentFunctionCodeMaintenance ( file ) {

    const endPoint = `${basePath}/component-function-code-upload`;
    const formData = new FormData();
    formData.append( 'file', file );

    const options = {
        body: formData,
        method: 'POST',
    };

    try {

        const response = await fetchService.fetchforFileUpload( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}

export async function uploadProductStructureMaintenance ( file ) {

    const endPoint = `${basePath}/product-structure-maintenance-upload`;
    const formData = new FormData();
    formData.append( 'file', file );

    const options = {
        body: formData,
        method: 'POST',
    };

    try {

        const response = await fetchService.fetchforFileUpload( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}

export async function uploadPartGroupMaintenance ( file ) {

    const endPoint = `${basePath}/part-group-maintenance-upload`;
    const formData = new FormData();
    formData.append( 'file', file );

    const options = {
        body: formData,
        method: 'POST',
    };

    try {

        const response = await fetchService.fetchforFileUpload( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}